import { render } from "./Step4Purchaser.vue?vue&type=template&id=19fc7e4a&scoped=true"
import script from "./Step4Purchaser.vue?vue&type=script&lang=js"
export * from "./Step4Purchaser.vue?vue&type=script&lang=js"

import "./Step4Purchaser.vue?vue&type=style&index=0&id=19fc7e4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fc7e4a"]])

export default __exports__